import React from 'react';

import PaymentsFilterComponent from './payments-filter.component';

export default function PaymentsFilter(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    return <PaymentsFilterComponent {...props} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />;
}
